import { Manager } from '@/domain/mitarbeiter/shared/entities/Manager';
import { useManager } from '@/domain/mitarbeiter/shared/hooks/useManager/useManager';
import { useStandortContext } from '@/features/standortContext/StandortContext';
import { Avatar, AvatarGroup } from '@e2n/ui/v2';

export function AvatarBox({ managerIds }: { managerIds: string[] }) {
  const { currentStandort } = useStandortContext();
  const { manager } = useManager(currentStandort.id);

  const mappedManagers = managerIds
    .map((id) => manager.find((m) => m.id === id))
    .filter((m): m is Manager => !!m);
  const displayedManagers = mappedManagers.slice(0, 4);
  const remainingManagers = mappedManagers.slice(4);
  return (
    <AvatarGroup>
      {displayedManagers.map((m) => (
        <Avatar
          key={m.id}
          type="initials"
          initials={`${m.vorname.charAt(0).toUpperCase()}${m.nachname.charAt(0).toUpperCase()}`}
        />
      ))}
      {remainingManagers.length > 0 && (
        <Avatar type="initials" initials={`+${remainingManagers.length}`} />
      )}
    </AvatarGroup>
  );
}
